/**
 * Shared brand colours for the training-course pages. Kept in one file so the
 * staff detail page and the public register page always agree on which colour
 * belongs to which section.
 *
 * ProDecor's brand gold is deliberately kept as an accent only — as a
 * full-page background it reads as harsh yellow, so ProDecor courses use the
 * neutral Ox green background alongside the other neutral / multi-section
 * pages.
 */
export const BRAND = {
  green:    { primary: '#0F7A45', dark: '#0A5C34', ink: '#FFFFFF', tint: '#E7F5EE' },
  probound: { primary: '#2F5E96', dark: '#1F406B', ink: '#FFFFFF', tint: '#E7EFF7' },
  proepoxy: { primary: '#7A0B7A', dark: '#520652', ink: '#FFFFFF', tint: '#F4E7F4' },
  // ProDecor palette exists so we can still tint accents (badges, small
  // borders) with the gold when we want to. It is NOT used as a background —
  // paletteForCourse() maps prodecor courses to `green` instead.
  prodecor: { primary: '#D5AB09', dark: '#8A6E00', ink: '#2B2101', tint: '#FBF6E8' },
};

/**
 * Pick the palette for a course.
 *   • single-section probound → probound blue
 *   • single-section proepoxy → proepoxy purple
 *   • anything else (single-section prodecor, multi-section, or missing) → Ox green
 */
export function paletteForCourse(course) {
  const sections = course?.sections || [];
  if (sections.length === 1) {
    if (sections[0] === 'probound') return BRAND.probound;
    if (sections[0] === 'proepoxy') return BRAND.proepoxy;
  }
  return BRAND.green;
}

/**
 * Accent palette for small elements (date pills, icon tiles). Same as
 * paletteForCourse but ProDecor gets its gold — fine at badge size, too
 * harsh as a full-page header background.
 */
export function accentForCourse(course) {
  const sections = course?.sections || [];
  if (sections.length === 1 && sections[0] === 'prodecor') return BRAND.prodecor;
  return paletteForCourse(course);
}
